"use client"
import { useContext } from "react"
import { UserContext } from "../../context/UserContext"
import Link, { type LinkProps } from "../Link/Link"

export function MyWishListLink(props: Omit<LinkProps, 'href'>) {
  const { children, ...otherProps } = props;
  const { isLogged } = useContext(UserContext)
  const href: string = isLogged ? '/customer/dashboard/wishlist' : '/customer/login'

  return (
    <Link href={href} {...otherProps}>
      {children} 
    </Link>
  );
}
